<template>
    <div class="container">
        <div class="intro-contain">
            <div class="intro-title">
                <h2 class="title-name">安得简介</h2>
                <span class="intro-play" @click="clickTr($event)">视频版简介</span>
                <div class="video_bg" v-if="videoVis">
                    <a class="t_close" @click="closeDetail"></a>
                    <div class="QT_bg_desc">
                        <!-- 要换成生产地址 -->
                        <video id="videoID" src="https://oss-cn-foshan-2.midea.com/oss/auth/userDownload/y4h62Ebn9wN4Qn3N9LDabePW/cdn/%E5%AE%89%E5%BE%97%E6%99%BA%E8%81%94%E4%BC%81%E5%AE%A32022-0713.m4v?certification=v1d853bfc53c67f7f3d4e9117571a8a5d6a9" controls="controls"></video>
                    </div>
                </div>
            </div>
            <p class="content">安得智联是一家致力于为客户提供端到端数智化供应链解决方案的物流科技企业。</p>
            <br>
            <p class="content">
                基于美的 T+3 产销模式及渠道一盘货变革的经营实践，安得智联建立了端到端全链路数智化的物流运营迭代能力，可为客户提供从原料至成品的生产精益物流，线上线下一盘货，To b/C 一体化，仓干配一体化，及送装服务的一体化供应链解决方案，协助企业推动渠道变革与供应链效率优化，提升竞争优势，助力客户实现可持续性发展。
            </p>
            <br>
            <p class="content">安得智联在全国拥有 29 家分公司，136 个配送中心，3000 个送装网点，1500 个前置仓；近 20 万条成熟线路，配送网络覆盖 3.9 万个乡镇，覆盖全国 99.1% 的乡镇。</p>
            <br>
            <p class="content">针对不同场景下的客户需求，打造标准化产品服务、行业方案及数智化能力，目前安得智联已为家电家居、泛快消、3C 等行业超 3000 家企业客户，提供定制化、集约化、数智化的一体化供应链物流解决方案，助力企业实现全链路、全渠道经营，将物流由成本中心转化为价值中心。</p>
            <br>
            <p class="content">目前，在全国拥有职工 7900 余名，人员结构呈数字化 IT 及创新业务专才增加，干部年轻化、高学历人才占比呈上升趋势。</p>
            <br>
            <p class="content">安得智联专注于持续的技术进步和创新。通过技术革新，<b>安得智联一盘货入选国家发改委“物流业制造业深度融合创新发展典型案例”</b>、高新技术企业证书、国家认定企业技术中心、中国驰名商标、科技进步奖二等奖、2022LOG 低碳供应链 & 物流创新优秀企业等各类荣誉奖项。</p>
            <br>
            <div class="intro-title">
                <h2 class="title-name">发展历程</h2>
            </div>
            <div>
                <div class="steps">
                    <el-steps :active="active" align-center process-status="finish" finish-status="wait">
                        <el-step v-for="(item, index) in yearList" :title="item" :key="item"  
                        @mouseover.native="mouseover(index)" @click.native="mouseover(index)"></el-step>
                    </el-steps>
                </div>
                <div class="develop" v-if="yearList[active] === '2021'">
                    <div class="develop-content">
                        <p class="blue-bg">收入跨越118亿</p>
                        <p>推进三大战略主轴：产品经营、数智创新、效率驱动</p>
                        <p>布局前置仓模式，推进全链路交付变革</p>
                        <p>“一盘货”案例入选国家发改委“物流业制造业深度融合创新发展典型案例”，被证明是全渠道高效交付的有效路径</p>
                    </div>
                    <img class="develop-img" src="../../images/devolop/develop1.jpg" alt="">
                </div>
                <div class="develop" v-if="yearList[active] === '2020'">
                    <div class="develop-content">
                        <p>确立1+3商业模式：全链路，生产物流+全渠道一盘货/仓干配一体化+2C送装一体</p>
                        <p>加快推进“一盘货”方案社会化的接纳程度，推进行业供应链变革</p>
                    </div>
                    <img class="develop-img" src="../../images/devolop/develop2.jpg" alt="">
                </div>
                <div class="develop" v-if="yearList[active] === '2019'">
                    <div class="develop-content">
                        <p>加快由企业物流向物流企业转型，“一盘货”方案向社会化推广</p>
                    </div>
                    <img class="develop-img" src="../../images/devolop/develop3.jpg" alt="">
                </div>
                <div class="develop" v-if="yearList[active] === '2015-2018'">
                    <div class="develop-content">
                        <p class="blue-bg">收入40-60亿</p>
                        <p><b>“一盘货”</b></p>
                        <p>实施“一盘货”统仓统配业务变革，推动美的经销渠道经营转型</p>
                    </div>
                    <img class="develop-img" src="../../images/devolop/develop4.jpg" alt="">
                </div>
                <div class="develop" v-if="yearList[active] === '2011-2014'">
                    <div class="develop-content">
                        <p class="blue-bg">收入20-40亿</p>
                        <p><b>物流企业</b></p>
                        <p>成为5A综合性物流企业 拓展电商领域</p>
                    </div>
                    <img class="develop-img" src="../../images/devolop/develop1.jpg" alt="">
                </div>
                <div class="develop" v-if="yearList[active] === '2010'">
                    <div class="develop-content">
                        <p class="blue-bg">收入0-20亿</p>
                        <p><b>全面信息化</b></p>
                        <p>上线信息化系统</p>
                    </div>
                    <img class="develop-img" src="../../images/devolop/develop2.jpg" alt="">
                </div>
                <div class="develop" v-if="yearList[active] === '2000'">
                    <div class="develop-content">
                        <p class="blue-bg">公司创立</p>
                    </div>
                    <img class="develop-img" src="../../images/devolop/develop3.jpg" alt="">
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    metaInfo: {
        title: '安得智联-简介|智慧园区',
        meta: [{                 // set meta
            name: 'keyWords',
            content: '智慧园区'
        },{                 // set meta
            name: 'description',
            content: '安得智联成立于2000年1月,注册资金6.765亿元,拥有30家地区分公司,在全国拥有136个配送中心,6万余城配车、3000+最后一公里送装网点,全面覆盖3-5级市场、2875个县/区、39862个乡镇,配送网络覆盖全国100%辖区内乡镇.'
        }]
    },
    name: 'intor',
    data() {
        return {
            videoVis: false,
            yearList:['2021', '2020', '2019', '2015-2018', '2011-2014', '2010', '2000'],
            active:0
        };
    },
    methods: {
        mouseover(index) {
            this.active =  index;
        },
        clickTr(e) {
            e.preventDefault();
            this.showDetail();
            this.$nextTick(() => {
                document.getElementById('videoID').play();
                document.getElementById('videoID').volume = 0.3;
                document.getElementById('videoID').currentTime = 0;
            });
            if (window._paq) {
                window._paq && window._paq.push(['trackEvent', '观看完整视频', 'click', '安得简介']);
            }
        },
        showDetail() {
            document.body.style.overflow = 'hidden';
            this.videoVis = true;
        },
        closeDetail() {
            document.getElementById('videoID').pause();
            document.body.style.overflow = 'auto';
            this.videoVis = false;
        }
    }
};
</script>

<style lang="less">
.intro-contain {
    margin: 0 auto;
    padding: 1rem 1rem 1.3rem 1rem;
    .intro-title {
        .title-name {
            font-size: 32px;
            color: #333333;
            margin: 0 0.1em 1em 0;
            font-weight: bold;
            display: inline-block;
        }
        .intro-play {
            font-size: 20px;
            cursor: pointer;
            &:before {
                content: ' ';
                display: inline-block;
                width: .28rem;
                height: .28rem;
                background: url(../../images/icon/about_play.png) center no-repeat;
                background-size: 100%;
                margin: 0 0.1rem;
                vertical-align: sub;
            }
        }
    }
    .intro-title:not(:first-child) {
        margin-top: 32px;
    }
    .content {
        line-height: 0.38rem;
        font-size: 18px;
        color: #333333;
        b {
            font-weight: 600;
        }
    }
    .video_bg {
        position: fixed;
        z-index: 10;
        width: 100%;
        height: 100%;
        bottom: 0;
        left: 0;
        background: rgba(0, 0, 0, 0.8);
        overflow-y: scroll;
        display: flex;
        align-items: center;
        .t_close {
            display: block;
            width: 0.5rem;
            height: 0.5rem;
            border-radius: 100%;
            background: url(../../images/icon/close.png) center center no-repeat
                #34383c;
            position: absolute;
            right: 0.1rem;
            top: 0.1rem;
            z-index: 20;
            cursor: pointer;
        }
        .QT_bg_desc {
            margin: 0 auto;
            width: 60%;
            border-radius: 0.1rem;
            video {
                width: 100%;
            }
        }
    }
    .develop {
        box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
        height: 300px;
        width: 100%;
        margin-top: 20px;
        padding: 20px 0;
        display: flex;
        &-content{
            display: inline-block;
            flex: 1;
            vertical-align: top;
            padding-right: 50px;
            padding-left: 50px;
        }
        &-img {
            display: inline-block;
            width: 416px;
            height: 300px;
            margin-right: 50px;
        }
        p {
            font-size: 18px;
            margin-top: 15px;
            line-height: 24px;
        }
        .blue-bg {
            display: inline-block;
            background: #4285f5;
            padding: 3px 6px;
            color: #fff;
        }
        b {
            font-weight: 600;
        }
    }
    .el-step__head.is-finish {
        .el-step__icon.is-text {
            color: #4285f5; 
            border-color: #4285f5;
            font-weight: 600;
        }
    }
    .el-step__title.is-finish {
        color: #4285f5; 
        font-weight: 600;
    }

}

@media screen and (min-width: 840px) and (max-width: 1079px) {
    .intro-contain {
        .intro-title {
            .title-name {
                font-size: 28px;
            }
        }
        .intro-title:not(:first-child) {
            margin-top: 28px;
        }
        .content {
            font-size: 16px;
        }
        .video_bg {
            .QT_bg_desc {
                width: 70%;
            }
        }
        .develop {
            box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
            width: 100%;
            margin: 10px 0;
            padding: 20px 0;
            display: flex;
            height: auto;
            &-content{
                vertical-align: top;
                padding-right: 10px;
                padding-left: 10px;
                flex: 1;
                width: 100%;
            }
            &-img {
                width: 300px;
                margin: 10px;
                height: 150px;
            }
            p {
                font-size: 14px;
                margin-top: 8px;
                line-height: 16px;
            }
        }
    }
    .el-step__title {
        font-size: 14px;
    }
}

@media screen and (min-width: 481px) and (max-width: 839px) {
    .intro-contain {
        .intro-title {
            .title-name {
                font-size: 24px;
            }
        }
        .intro-title:not(:first-child) {
            margin-top: 24px;
        }
        .content {
            font-size: 14px;
        }
        .video_bg {
            .QT_bg_desc {
                width: 80%;
            }
        }
        .develop {
            box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
            width: 100%;
            margin: 10px 0;
            padding: 20px 0;
            display: block;
            height: auto;
            &-content{
                vertical-align: top;
                padding-right: 10px;
                padding-left: 10px;
                width: 100%;
            }
            &-img {
                width: calc(100% - 20px);
                margin: 10px;
                height: 300px;
            }
            p {
                font-size: 12px;
                margin-top: 8px;
                line-height: 16px;
            }
        }
    }
    .el-step__title {
        font-size: 12px;
    }
    .el-step__icon.is-text {
        border: 1px solid;
    }
    .steps {
        width: 100%;
        overflow-x: auto;
        overflow-y: hidden;
    }
    .el-steps {
        min-width: 600px;
    }
}

@media screen and (max-width: 480px) {
    .intro-contain {
        padding: .15rem 0.3rem;
        .intro-title {
            display: block;
            text-align: center;
            margin-bottom: 0.25rem;
            background: none;
            width: 100%;
            .title-name {
                font-size: 16px;
                top: 0;
                line-height: unset;
                color: #666;
            }
            .intro-play {
                font-size: 14px;
                &:before {
                    width: 0.16rem;
                    height: 0.16rem;
                    margin: 0 0.05rem;
                }
            }
        }
        .content {
            line-height: 0.2rem;
            font-size: 12px;
            color: #666666;
        }
        .video_bg {
            background: #000000;
            .QT_bg_desc {
                width: 100%;
            }
            .t_close {
                top: 0.55rem;
                width: 0.3rem;
                height: 0.3rem;
            }
        }
        .develop {
            box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
            width: 100%;
            margin: 10px 0;
            padding: 20px 0;
            display: block;
            height: auto;
            &-content{
                vertical-align: top;
                padding-right: 10px;
                padding-left: 10px;
                width: calc(100% - 20px);
            }
            &-img {
                width: calc(100% - 20px);
                margin: 10px;
                height: 200px;
            }
            p {
                font-size: 12px;
                margin-top: 8px;
                line-height: 16px;
            }
        }
    }
    .el-step__title {
        font-size: 12px;
    }
    .el-step__icon.is-text {
        border: 1px solid;
    }
    .steps {
        width: 100%;
        overflow-x: auto;
        overflow-y: hidden;
    }
    .el-steps {
        min-width: 600px;
    }
}
</style>